const InfrastructureElementType = {
	BRIDGE: 'Bridge',
	OTHER: 'Other'
};

export default InfrastructureElementType;
